// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"132":"23ce9413","155":"e79340f0","961":"2a9dd978"}[chunkId] + ".js";
};